var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"navbar-item settings",on:{"click":function($event){return _vm.$store.commit('layout/settingsBar/toggle')}}},[_c('span',{staticClass:"icon"},[_c('fa',{attrs:{"icon":"cogs"}})],1)])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ee96b40c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/core/structure/navbar/SettingsControl.vue
// module id = ns6Q
// module chunks = 66